import styled from 'styled-components';

export const AmenitiesDetailsWrapper = styled.div(
  props => `
    padding-top:${!props.paddingTop ? props.theme.spacing.base : props.paddingTop};
    display:flex;
    flex-direction:row;
`,
);

export const MealsSpan = styled.span(
  props => `
    padding-right:${props.theme.spacing.base};
    font-size:${props.theme.font.custom(12)};
    color:${props.color ? props.color : ''};
    
`,
);

export const RedAlertSpan = styled.span(
  props => `
    font-size:${props.theme.font.custom(12)};
    color:${props.color ? props.color : props.theme.colors.goRed.base};
`,
);

export const GreenAlertSpan = styled.span(
  props => `
    font-size:${props.theme.font.custom(12)};
    color:${props.theme.colors.goGreen.base};
`,
);

export const DividerSpan = styled.span(
  props => `
  width: 1px;
    background: #141823;
    margin-right: 1rem;
  `,
);
